import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  borderRadius,
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const wrap = css`
  max-width: ${width.container.large};
  margin: ${size[40]} auto;
`

export const title = (theme: Theme) => css`
  font-size: ${pxToRem(28)};
  color: ${theme.palette.text.title};
  font-weight: 700;
  margin-inline: ${size[24]};
  margin-bottom: ${size[32]};

  span {
    color: ${theme.palette.primary.mainContrast};
  }

  ${breakpoint.up('smMd')} {
    text-align: center;
    font-size: ${pxToRem(48)};
    margin-inline: unset;
    margin-bottom: ${size[48]};
  }
`

export const mediaWrapper = (theme: Theme) => css`
  position: relative;
  width: fit-content;
  margin: auto;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      to bottom,
      #00000000,
      #01000011,
      #01000022,
      #01000155,
      #010001cc,
      #010002ff
    );
  }

  ${breakpoint.up('smMd')} {
    &::before {
      border-radius: ${theme.borderRadius.lg};
    }
  }
`

export const desc = (theme: Theme) => css`
  position: absolute;
  bottom: ${size[24]};
  left: ${size[24]};
  width: calc(100% - 48px);
  max-width: ${width.container.standard};
  color: ${theme.palette.secondary.reversedContrast};
  font-size: ${pxToRem(14)};
  line-height: 20px;
  pointer-events: none;

  ${breakpoint.up('smMd')} {
    bottom: ${size[80]};
    width: 80%;
    left: ${size[96]};
    line-height: initial;
    font-size: ${pxToRem(24)};
  }
`

export const video = (theme: Theme) => css`
  aspect-ratio: 16 / 9;

  ${breakpoint.up('smMd')} {
    border-radius: ${theme.borderRadius.lg};
  }
`

export const play = (theme: Theme) => css`
  border-radius: ${borderRadius.circle};
  background-color: ${theme.palette.background.main};
  position: absolute;
  padding: ${size[32]};
  left: calc(50% - 60px);
  top: calc(50% - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; // allow clicking on the video through the button
`

export const playBorder = css`
  position: absolute;
  border-radius: ${borderRadius.circle};
  left: calc(50% - 82px);
  top: calc(50% - 82px);
  border-radius: 50%;
  width: ${size[128]};
  height: ${size[128]};
  background: #ffffff40;
  pointer-events: none;
`
